import { useState } from 'react'
import { Link } from 'react-router'
import { auth } from '@/api/endpoints'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Err } from '@/components/Err'
import { AuthCard } from './Card'

// 비밀번호 찾기(F-33). 주소 하나를 받고, 계정이 있든 없든 같은 문장으로 끝난다.

export default function ResetRequest() {
  const [email, setEmail] = useState('')
  const [busy, setBusy] = useState(false)
  const [done, setDone] = useState(false)
  const [error, setError] = useState<unknown>(null)
  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await auth.requestReset(email.trim())
      setDone(true)
    } catch (err) {
      setError(err)
    } finally {
      setBusy(false)
    }
  }
  return (
    <AuthCard title="비밀번호 찾기" onSubmit={submit}>
      {done ? (
        <>
          <p className="text-[13px]">계정이 있는 주소라면 재설정 링크를 보냈습니다.</p>
          <Button asChild variant="outline"><Link to="/">로그인</Link></Button>
        </>
      ) : (
        <>
          <Input type="email" placeholder="이메일" autoComplete="email" maxLength={254} value={email} disabled={busy} onChange={(e) => setEmail(e.target.value)} />
          <Button type="submit" disabled={busy || !email.trim()} className="bg-brand hover:bg-brand-hover">{busy ? '보내는 중' : '링크 보내기'}</Button>
          <Err error={error} />
          <Link to="/" className="text-center text-[12px] text-muted-foreground hover:text-foreground hover:underline">로그인</Link>
        </>
      )}
    </AuthCard>
  )
}
